import data from "../../../../../packages/react/src/deprecated/FilterList/FilterList.docs.json";
import * as React from 'react';
export default {
  data,
  React
};